import React from 'react';
import { useRoomContext, useParticipants } from '@livekit/components-react';
import { FILTER_IDS } from '../filters/filters';

const OPTIONS = [
  FILTER_IDS.LEADER,
  FILTER_IDS.LAST,
  FILTER_IDS.CORRECT,
  FILTER_IDS.WRONG,
  FILTER_IDS.NEUTRAL,
];

const HostDebugPanel = ({ isHost }) => {
  const room = useRoomContext();
  const participants = useParticipants();

  if (process.env.NODE_ENV !== 'development' || !isHost || !room) return null;

  const broadcast = (identity, filterId) => {
    const payload = JSON.stringify({
      type: 'filterState',
      standings: { [identity]: filterId },
      transient: {},
    });
    try {
      room.localParticipant.publishData(new TextEncoder().encode(payload), {
        reliable: true,
      });
    } catch (e) {
      console.error('HostDebugPanel publishData failed:', e);
    }
  };

  return (
    <div
      style={{
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 100,
        padding: 10,
        background: 'rgba(0,0,0,0.85)',
        color: '#fff',
        fontFamily: 'ui-monospace, monospace',
        fontSize: 11,
        borderRadius: 8,
        maxWidth: 360,
        maxHeight: '50vh',
        overflow: 'auto',
      }}
    >
      <div style={{ marginBottom: 6, opacity: 0.6, letterSpacing: 1 }}>
        HOST FILTER DEBUG (dev)
      </div>
      {participants.length === 0 && (
        <div style={{ opacity: 0.5 }}>no participants yet</div>
      )}
      {participants.map((p) => (
        <div key={p.identity} style={{ marginBottom: 6 }}>
          <div style={{ marginBottom: 2 }}>{p.identity}</div>
          <div>
            {OPTIONS.map((f) => (
              <button
                key={f}
                onClick={() => broadcast(p.identity, f)}
                style={{
                  marginRight: 4,
                  marginBottom: 2,
                  padding: '2px 6px',
                  fontSize: 10,
                  background: '#333',
                  color: '#fff',
                  border: '1px solid #555',
                  borderRadius: 3,
                  cursor: 'pointer',
                }}
              >
                {f}
              </button>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default HostDebugPanel;
